/**
 * Runtime-Konfiguration des Frontends.
 *
 * Im Produktiv-Setup injiziert nginx eine `/config.js` mit
 *   window.__CIVIPORT_CONFIG__ = { keycloakUrl, realm, clientId, apiBaseUrl }
 * Im Dev-Modus fallen wir auf die hier definierten Defaults zurueck.
 */
export interface CiviPortConfig {
  keycloakUrl: string;
  realm: string;
  clientId: string;
  apiBaseUrl: string;
}

declare global {
  interface Window {
    __CIVIPORT_CONFIG__?: Partial<CiviPortConfig>;
  }
}

const defaults: CiviPortConfig = {
  // Dev-Default: lokales Keycloak ueber den Override-Port.
  keycloakUrl: 'http://localhost:8080',
  realm: 'civiport',
  clientId: 'civiport-frontend',
  // Im Dev laeuft Vite auf 5173, der api-Service auf 3000 (per nginx-Proxy /api/).
  // Im Prod laeuft beides ueber Traefik unter der gleichen Origin.
  apiBaseUrl: '',
};

export const config: CiviPortConfig = {
  ...defaults,
  ...(typeof window !== 'undefined' ? window.__CIVIPORT_CONFIG__ : undefined),
};
